import { render, staticRenderFns } from "./appUploader.vue?vue&type=template&id=4bfd9aba&"
import script from "./appUploader.vue?vue&type=script&lang=js&"
export * from "./appUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports